import { AbstractModel } from '@uzurv/core';
import { autoserialize, autoserializeAs, inheritSerialization } from 'cerialize';
import { ServiceLevel } from './service-level';

@inheritSerialization(AbstractModel)
export class OrganizationServiceLevel extends AbstractModel {
  @autoserialize
  organizationId: number;

  @autoserializeAs(ServiceLevel)
  serviceLevel: ServiceLevel;

  @autoserialize
  optional: boolean;

  @autoserialize
  minimumMinutesBeforeScheduledRideAllowed: number;

  @autoserialize
  rideNowEnabled: boolean;

  @autoserialize
  willCallEnabled: boolean;

  @autoserialize
  scheduledEnabled: boolean;
}
